module.exports = __webpack_public_path__ + "img/websites_greyscale.80341042.jpg";